import log from 'loglevel'
import moment from 'moment-timezone'
import { ATTRIBUTE_TYPE } from 'ifield-core-components'
import { SERVER_TIMEZONE, DATETIME_FORMAT_API } from '@/constants'

/**
 * ローカルのタイムゾーンを取得する
 * @returns {string} タイムゾーン
 */
export const getLocalTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

/**
 * 指定のタイムゾーン変換を行う
 * @param {string|number} dt 変換する日時
 * @param {string} from 変換元タイムゾーン
 * @param {string} to 変換先タイムゾーン
 * @returns {Moment} 変換後日時
 */
export const convertTz = (dt, from, to) => {
  if (!from || !to) {
    log.warn('timezone from or to not passed', from, to)
    return null
  }

  const m = moment.tz(dt, from)
  if (!m.isValid()) {
    log.warn('invalid datetime', dt)
    return null
  }
  return m.tz(to)
}

/**
 * ローカルタイムゾーン日時をサーバータイムゾーン日時に変換する
 * 引数が nullish もしくは日付としてparseできない場合は null を返却する
 * @param {string|number} dt 変換する日時(ローカルタイムゾーン)
 * @param {string} [format=DATETIME_FORMAT_API] 変換先フォーマット
 * @returns {string} 変換後日時文字列(サーバータイムゾーン)
 */
export const toServerTz = (dt, format = DATETIME_FORMAT_API) => {
  if (dt == null) return null
  const m = convertTz(dt, getLocalTimezone(), SERVER_TIMEZONE)
  return m?.format(format) || null
}

/**
 * サーバータイムゾーン日時をローカルタイムゾーン日時に変換する
 * 引数が nullish もしくは日付としてparseできない場合は null を返却する
 * @param {string|number} dt 変換する日時(サーバータイムゾーン)
 * @param {string} [format=DATETIME_FORMAT_API] 変換先フォーマット
 * @returns {string} 変換後日時文字列(ローカルタイムゾーン)
 */
export const toLocalTz = (dt, format = DATETIME_FORMAT_API) => {
  if (dt == null) return null
  const m = convertTz(dt, SERVER_TIMEZONE, getLocalTimezone())
  return m?.format(format) || null
}

/**
 * 属性値のサーバータイムゾーン日時をローカルタイムゾーン日時に変換する(属性値)
 * 引数が nullish もしくは日付としてparseできない場合は null を返却する
 * @param {Object} attribute 変換する属性レコード(サーバータイムゾーン)
 * @param {string} [valueField='attribute_value'] 値のフィールド名
 * @param {string} [format] 変換先フォーマット(toLocalTzにそのまま渡す)
 * @returns {Object} 変換後属性レコード(ローカルタイムゾーン)
 */
export const toLocalTzAttribute = (
  attribute,
  valueField = 'attribute_value',
  format
) => {
  if (attribute.attribute_type == ATTRIBUTE_TYPE.DATETIME) {
    return {
      ...attribute,
      [valueField]: attribute[valueField]
        ? toLocalTz(attribute[valueField], format)
        : attribute[valueField],
    }
  } else {
    return attribute
  }
}
